import type { ExtendedPrimitives } from '@rfc/rfc-components-library/types'
import moment from 'moment'
import * as momentTz from 'moment-timezone'

export type EventCreateModel = {
    comments: string

    end_at: Date | null
    name: string
    start_at: Date | null
    partner_config?: Record<string, ExtendedPrimitives> | undefined
    partner_id?: number
    tz: string
}

export const defaultEventCreateModel = {
    comments: '',
    start_at: moment().startOf('d').utc().toDate(),
    end_at: moment().endOf('d').utc().add(1, 'd').toDate(),
    name: '',
    tz: momentTz.tz.guess()
}
